import React from "react"

import Navbar from "./NAVIGATION/Navbar"
import Footer from "./NAVIGATION/Footer"

export default class Layout extends React.Component
{
    render()
    {
        const shouldSee = this.props.hide ? "none" : "block"

        return (
            <div id="app" style={{minHeight: "77vh"}}>
                <Navbar shouldSee={shouldSee} />
                {this.props.children}
                <Footer />
            </div>
        )
    }
}
